export const SET_TOKEN = 'SET_TOKEN'
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL'